module.exports = __webpack_public_path__ + "img/excel.cd79415e.png";